import React from "react";

const OldestUnpaidInvoice = ({ creditDetails }) => {
    if (!creditDetails) return null;

    // Calculate overdue days from the credit details
    const overdueDays = creditDetails.overdue_days || 0;

    // Determine status based on overdue days
    let status = "Okay";
    let statusColor = "#22C55E";
    let bgColor = "#DCFCE7";
    let borderColor = "#22C55E";

    if (overdueDays >= 30) {
        status = "Very High";
        statusColor = "#EF4444";
        bgColor = "#FEF2F2";
        borderColor = "#EF4444";
    } else if (overdueDays >= 16) {
        status = "High";
        statusColor = "#F97316";
        bgColor = "#FFF7ED";
        borderColor = "#F97316";
    } else if (overdueDays >= 11) {
        status = "Needs Attention";
        statusColor = "#F59E0B";
        bgColor = "#FFFBEB";
        borderColor = "#F59E0B";
    }

    return (
        <div
            style={{
                width: "100%",
                height: "79px",
                borderRadius: "10px",
                opacity: 1,
                gap: "10px",
                borderWidth: "1px",
                padding: "12px 14px",
                background: "#FFFFFF",
                border: "1px solid #EFEFEF",
                marginTop: "16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <div style={{ display: "flex", alignItems: "stretch" }}>
                <div
                    style={{
                        width: "3px",
                        minHeight: "45px",
                        backgroundColor: "#6EAAA3",
                        borderRadius: "2px",
                        marginRight: "12px",
                    }}
                />
                <div>
                    <div
                        style={{
                            fontFamily: "Manrope",
                            fontWeight: 500,
                            fontSize: "12px",
                            lineHeight: "11.52px",
                            letterSpacing: "0px",
                            color: "#3D3D3DCC",
                            marginBottom: "8px",
                        }}
                    >
                        Oldest unpaid invoice
                    </div>
                    <div
                        style={{
                            fontFamily: "Manrope",
                            fontWeight: 600,
                            fontSize: "18px",
                            lineHeight: "100%",
                            letterSpacing: "0px",
                            color: statusColor,
                        }}
                    >
                        {overdueDays} Days
                    </div>
                </div>
            </div>

            <div
                style={{
                    minWidth: "43.94px",
                    height: "23px",
                    borderRadius: "13.06px",
                    opacity: 1,
                    gap: "6.73px",
                    borderWidth: "0.98px",
                    padding: "4px 8.97px",
                    background: bgColor,
                    border: `0.98px solid ${borderColor}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <span
                    style={{
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        fontWeight: 500,
                        color: statusColor,
                        whiteSpace: "nowrap",
                    }}
                >
                    {status}
                </span>
            </div>
        </div>
    );
};

export default OldestUnpaidInvoice;
